export const TOKEN_COLOR = {
    primary: '#1565c0',
    primaryDark: '#0d47a1',
    success: '#2e7d32',
    warning: '#e65100',
    warningSoft: '#f57c00',
    danger: '#c62828',
    accent: '#5e35b1',
    teal: '#00695c',
    indigo: '#3949ab',
    primaryBg: '#e3f2fd',
    successBg: '#e8f5e9',
    warningBg: '#fff3e0',
    softYellowBg: '#fff8e1',
    dangerBg: '#ffebee',
    accentBg: '#ede7f6',
    indigoBg: '#e8eaf6',
    tealBg: '#e0f2f1',
    greyBg: '#f3f4f6',
    grey: '#9ca3af',
    text: '#1a1a2e',
    textSecondary: '#888',
    textMuted: '#999',
};

export const KPI_PALETTE = {
    blue:   { bg: TOKEN_COLOR.primaryBg,    fg: TOKEN_COLOR.primary },
    green:  { bg: TOKEN_COLOR.successBg,    fg: TOKEN_COLOR.success },
    red:    { bg: TOKEN_COLOR.dangerBg,     fg: TOKEN_COLOR.danger },
    teal:   { bg: TOKEN_COLOR.tealBg,       fg: TOKEN_COLOR.teal },
    amber:  { bg: TOKEN_COLOR.softYellowBg, fg: TOKEN_COLOR.warning },
    purple: { bg: TOKEN_COLOR.accentBg,     fg: TOKEN_COLOR.accent },
    indigo: { bg: TOKEN_COLOR.indigoBg,     fg: TOKEN_COLOR.indigo },
    grey:   { bg: TOKEN_COLOR.greyBg,       fg: TOKEN_COLOR.grey },
};

export const HISTORY_STATUS_STYLE = {
    ACTIVE:    { borderColor: TOKEN_COLOR.primary,     bg: TOKEN_COLOR.indigoBg,     chipColor: 'info' },
    MISSED:    { borderColor: TOKEN_COLOR.warningSoft, bg: TOKEN_COLOR.softYellowBg, chipColor: 'warning' },
    DELIVERED: { borderColor: TOKEN_COLOR.success,     bg: TOKEN_COLOR.successBg,    chipColor: 'success' },
};

export const BANNER_VARIANT = {
    warning: {
        bg: 'linear-gradient(135deg,#fff3e0,#fbe9e7)',
        border: '#ffccbc',
        iconBg: TOKEN_COLOR.warning,
        titleColor: '#bf360c',
        bodyColor: '#4e342e',
    },
    danger: {
        bg: 'linear-gradient(135deg,#fce4ec,#ffebee)',
        border: '#ef9a9a',
        iconBg: TOKEN_COLOR.danger,
        titleColor: '#b71c1c',
        bodyColor: '#4e342e',
    },
    info: {
        bg: 'linear-gradient(135deg,#ede7f6,#e8eaf6)',
        border: '#d1c4e9',
        iconBg: TOKEN_COLOR.accent,
        titleColor: '#311b92',
        bodyColor: '#3e2723',
    },
    amber: {
        bg: 'linear-gradient(135deg,#fff8e1,#fff3e0)',
        border: '#ffe0b2',
        iconBg: TOKEN_COLOR.warning,
        titleColor: '#bf360c',
        bodyColor: '#4e342e',
    },
};
